import * as Redux from "redux";
import storage from "redux-persist/lib/storage";

import { UserActions } from "src/core/users/store/users.actions";
import * as AT from "src/core/users/store/users.constants";
import { IUser } from "src/core/users/api/users.api";
import { IOrderVariant } from "src/core/orders/api/orders.api";

export interface IUsersStore {
  user: IUser | null;
  accessibleOrderVariants: IOrderVariant[]
}

const initialState: IUsersStore = {
  user: null,
  accessibleOrderVariants: []
};

export const usersReducer: Redux.Reducer<IUsersStore> = (state: IUsersStore = initialState, action: UserActions): IUsersStore => {
  switch (action.type) {
    case AT.SET_USER:
      return {
        ...state,
        user: action.user
      };

    case AT.PURGE_USERS:
      return initialState;

    case AT.SET_USER_ACCESSIBLE_ORDER_VARIANTS:
      return {
        ...state,
        accessibleOrderVariants: action.accessibleOrderVariants
      };

    default:
      return state;
  }
};

// config for persisting within this reducer
export const usersPersistConfig = {
  key: "users",
  storage,
  blacklist: [ "" ]
};
